import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectUserId } from '@/redux/auth/auth.slice';
import UserPostsList from '@/redux/post/UserPostsList';
import { Title } from '@/components/ui/title';
import { Button } from '@/components/ui/button';

function MyModels() {
  const userId = useSelector(selectUserId);
  const { isAuthenticated, isVerified, user } = useSelector(selectCurrentUser);

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="px-5 md:px-[5rem] pb-24 pt-[10px]"
      style={{ marginTop: 'var(--nav-height)' }}
    >
      {isAuthenticated && isVerified && (
        <>
          <Title title="CNC Projects" />
          <div className="h-[270px] border-[#7C7C7C] flex items-center justify-center border-dashed border-[1.5px] rounded-md mb-[30px] flex-col">
            {/* <ModalUploadDialog
              modalDialog={modelDialog}
              setModalDialog={setModelDialog}
            /> */}
            <Button variant="default" asChild>
              <Link to="/project/create">Create Project</Link>
            </Button>
            <p className="w-auto sm:w-[537px] text-[#7C7C7C] text-center text-sm mt-[20px] sm:p-0 p-4">
              Upload your 3D model! After uploading, you`ll be prompted to add
              project details. We`ll review everything to ensure quality before
              it`s shared publicly.
            </p>
          </div>
        </>
      )}
      <Title title="My Projects" />
      <UserPostsList username={user.username} userId={userId} />
    </div>
  );
}

export default MyModels;
